import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { SearchAdvancedRequest } from "../Types/search-advanced-request";
import { SearchResponse } from "../Types/search-response";
import { SearchAdvancedResponse } from "../Types/search-advanced-response";
import { SearchRequestNative } from "../Types/search-request-native";
import { GenericSearchWithParametersRequest } from "../Types/generic-search-with-parameters-request";
import { GetItemsListResponse } from "../Types/get-items-list-response";

interface ISearchApiClient {
  SearchBasic(request: SearchRequestNative): Promise<SearchResponse>;
  SearchAdvanced(request: SearchAdvancedRequest): Promise<SearchAdvancedResponse>;
  SearchWithParameters(request: GenericSearchWithParametersRequest): Promise<GetItemsListResponse>;
}

export default class SearchApiClient implements ISearchApiClient {
  readonly servicePort = 9518;
  readonly serviceBaseUrl = "search-service/api";

  searchApiClient: IApiClient;

  constructor(searchApiClient: IApiClient, envType: EnvType) {
    this.searchApiClient = searchApiClient;
    if (envType === "local") this.searchApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  /*async SearchBasic(request: SearchRequest, abortSignal?: AbortSignal): Promise<SearchResponse> {
    return await this.searchApiClient.post(`${this.serviceBaseUrl}/search-basic`, request, abortSignal);
  }*/
  async SearchBasic(request: SearchRequestNative, abortSignal?: AbortSignal): Promise<SearchResponse> {
    return await this.searchApiClient.post(`${this.serviceBaseUrl}/search-basic-native`, request, abortSignal);
  }
  async SearchAdvanced(request: SearchAdvancedRequest): Promise<SearchAdvancedResponse> {
    return await this.searchApiClient.post(`${this.serviceBaseUrl}/search-advanced`, request);
  }

  async SearchWithParameters(request: GenericSearchWithParametersRequest): Promise<GetItemsListResponse> {
    return await this.searchApiClient.post(`${this.serviceBaseUrl}/search-orders`, request);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.searchApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
